import fileDownload from 'js-file-download';
import AGREGAR_PROYECTO_DOCUMENTO from '@/graphql/mutations/administracion/control-proyectos/documentos/agregarProyectoDocumento.gql';
import ACTUALIZAR_PROYECTO_DOCUMENTO from '@/graphql/mutations/administracion/control-proyectos/documentos/actualizarProyectoDocumento.gql';
import REMOVER_PROYECTO_DOCUMENTO from '@/graphql/mutations/administracion/control-proyectos/documentos/removerProyectoDocumento.gql';
import PROYECTO_DOCUMENTOS from '@/graphql/querys/administracion/control-proyectos/documentos/proyectoDocumentos.gql';

const BASE_URL = process.env.NODE_ENV !== 'production'
  ? 'http://localhost:3001'
  : 'https://sideop-file-server.hermosillo.gob.mx';

export default {
  methods: {
    // Agregar Proyecto Documento
    async mixAgregarProyectoDocumento() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo
        .mutate({
          mutation: AGREGAR_PROYECTO_DOCUMENTO,
          variables: {
            documentos: this.documentos,
          },
          update: (store, { data: { agregarProyectoDocumento } }) => {
            const query = {
              query: PROYECTO_DOCUMENTOS,
              variables: {
                idProyecto: this.idProyecto,
              },
            };
            const { proyectoDocumentos } = store.readQuery(query);
            const proyectoDocumentosCopia = proyectoDocumentos.slice();
            proyectoDocumentosCopia.push(...agregarProyectoDocumento);
            store.writeQuery({
              ...query,
              data: {
                proyectoDocumentos: proyectoDocumentosCopia,
              },
            });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    // Editar Proyecto Documento
    async mixActualizarProyectoDocumento() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo
        .mutate({
          mutation: ACTUALIZAR_PROYECTO_DOCUMENTO,
          variables: {
            id: this.proyectoDocumentoEditar.id,
            documento: this.documento,
          },
          update: (store, { data: { actualizarProyectoDocumento } }) => {
            const query = {
              query: PROYECTO_DOCUMENTOS,
              variables: {
                idProyecto: this.proyectoDocumentoEditar.idProyecto,
              },
            };
            const data = store.readQuery(query);
            const { proyectoDocumentos } = data;
            const index = proyectoDocumentos
              .findIndex((proyectoDocumento) => proyectoDocumento.id
              === actualizarProyectoDocumento.id);
            if (index !== -1) {
              proyectoDocumentos.splice(index, 1, actualizarProyectoDocumento);
            }
            store.writeQuery({ ...query, data });
          },
        }).then(() => {
          this.mixMensajeSuccess();
        }).catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    // Eliminar Proyecto Documento
    async mixEliminarProyectoDocumento() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: REMOVER_PROYECTO_DOCUMENTO,
        variables: {
          id: this.proyectoDocumentoEliminar.id,
        },
        update: (store) => {
          const query = {
            query: PROYECTO_DOCUMENTOS,
            variables: {
              idProyecto: this.proyectoDocumentoEliminar.idProyecto,
            },
          };
          const data = store.readQuery(query);
          const { proyectoDocumentos } = data;
          const index = proyectoDocumentos
            .findIndex((proyectoDocumento) => proyectoDocumento.id
            === this.proyectoDocumentoEliminar.id);
          if (index !== -1) {
            proyectoDocumentos.splice(index, 1);
          }
          store.writeQuery({ ...query, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    async mixDescargarDocumento(datosArchivo) {
      this.descargandoArchivo = true;
      await this.axios.get(
        `${BASE_URL}/${datosArchivo.public_key}`,
        {
          responseType: 'blob',
        },
      )
        .then((res) => {
          fileDownload(res.data, `${datosArchivo.name}.${datosArchivo.extension}`);
        })
        .catch((err) => {
          this.mixMensajeError(err.data.message);
        });
      this.descargandoArchivo = false;
    },
  },
};
